module.exports = __webpack_public_path__ + "static/media/in-number-8.b3216e83.png";